import React, { useState } from 'react';
import PeriodFilter from '../PeriodFilter/PeriodFilter.js';
import ClanStatsDetailsTable from '../ClanStatsDetailsTable/ClanStatsDetailsTable.js';
import { useParamsState } from '../../metadata/hooks.js';

const STRINGS = {
    CLAN_LEADERBOARD_STATS: gettext('Regiment Leaderboard Stats'),
}

function ClanStatsDetails({ clanData, selectedPeriod, setSelectedPeriod }) {

    return (
        <section>
            <h2>{STRINGS.CLAN_LEADERBOARD_STATS}</h2>
            <PeriodFilter selectedPeriod={selectedPeriod} setSelectedPeriod={setSelectedPeriod} />
            <ClanStatsDetailsTable clanData={clanData} selectedPeriod={selectedPeriod}/>
        </section>
    )
}

export default ClanStatsDetails;
